var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColoredCirclesAndSquares(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 391,
    viewBox: "0 0 266 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.1274,
    y: -65,
    width: 171.762,
    height: 137.409,
    rx: 16,
    fill: "#42B2FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -37.7412,
    cy: 321.741,
    r: 69.2588,
    fill: "#F182AD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.92238,
    cy: 5.92104,
    r: 69.2588,
    fill: "#FDCB6E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -107,
    y: 95.1265,
    width: 171.762,
    height: 137.409,
    rx: 16,
    fill: "#12B1B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredCirclesAndSquares);
export default __webpack_public_path__ + "static/media/colored-circles-and-squares.c9941d42e554d0a4e4cae02d9eb76316.svg";
export { ForwardRef as ReactComponent };